import React from "react";
import styled from "styled-components";
import { scrollbarCollor } from "../SideDarkModalOrg/SideDarkModalOrg.settings";
var StyledWrapper = styled.div.withConfig({
  componentId: "sc-1173jxu-0"
})(["height:100%;overflow:hidden;position:relative;"]);
var StyledContainer = styled.div.withConfig({
  componentId: "sc-1173jxu-1"
})(["height:100%;overflow:auto;", ""], scrollbarCollor);
var FullHeightContainer = styled.div.withConfig({
  componentId: "sc-1173jxu-2"
})(["height:100vh;"]);
function ParallaxWrapperOrg(_ref) {
  var children = _ref.children,
    hasFullHeight = _ref.hasFullHeight;
  var wrapper = /*#__PURE__*/React.createElement(StyledWrapper, null, /*#__PURE__*/React.createElement(StyledContainer, {
    id: "parallax-container"
  }, children));
  return hasFullHeight ? /*#__PURE__*/React.createElement(FullHeightContainer, null, wrapper) : wrapper;
}
export default ParallaxWrapperOrg;